import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path, Circle } from '../IconBase/IconBase'

function Ambulance({ color = 'icon.primary', fill = 'transparent', ...props }) {
  return (
    <IconBase viewBox='0 0 36 28' {...props}>
      <Path
        d='M9.88086 23.7074H23.6685'
        stroke={color}
        fill={fill}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />

      <Circle
        cx='26.0949'
        cy='23.7082'
        r='2.42691'
        stroke={color}
        fill={fill}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Circle
        cx='7.45425'
        cy='23.7082'
        r='2.42691'
        stroke={color}
        fill={fill}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M1.82617 16.2036H22.0504C22.4972 16.2036 22.8594 15.8414 22.8594 15.3946V5.10306C22.8594
         3.31594 21.4106 1.86719 19.6235 1.86719H5.06205C3.27492 1.86719 1.82617 3.31594 1.82617
          5.10306V22.0914C1.82617 22.985 2.55055 23.7093 3.44411 23.7093H5.02687'
        stroke={color}
        fill={fill}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M22.8574 5.10156H28.1102C29.8129 5.10156 31.3334 6.16794 31.9132 7.76893L33.9896
         13.5014C34.1175 13.8547 34.183 14.2276 34.183 14.6034V21.2809C34.183 22.6213 33.0964
          23.7078 31.7561 23.7078H28.5202'
        stroke={color}
        fill={fill}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M34.183 14.8132H29.3292L28.1851 13.6692C27.8817 13.3658 27.4702 13.1953 27.0411 13.1953H22.8574'
        stroke={color}
        fill={fill}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14.7496 7.9092H13.4416V6.6C13.4416 6.26863 13.173 6 12.8416 6H11.86C11.5286 6 11.26 6.26863
         11.26 6.6V7.9092H9.94961C9.61824 7.9092 9.34961 8.17783 9.34961 8.5092V9.4908C9.34961 9.82217
          9.61824 10.0908 9.94961 10.0908H11.2588V11.4C11.2588 11.7314 11.5274 12 11.8588 12H12.8416C13.173
           12 13.4416 11.7314 13.4416 11.4V10.0908H14.7496C15.081 10.0908 15.3496 9.82217 15.3496
            9.4908V8.5092C15.3496 8.17783 15.081 7.9092 14.7496 7.9092Z'
        fill={fill}
      />
    </IconBase>
  )
}

Ambulance.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default Ambulance
